module.exports = __webpack_public_path__ + "static/landing-ba429d978d3c2bae1f568fbd56c8b75f.png";